import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'

export const getQuestions = () => {
  switch (LOCALE) {
    case 'es-CO':
      return [
        {
          questions: '¿Qué es Pro-Defense V?',
          answer: (
            <p>
              Pro-Defense V es la nueva línea de productos Nosotras que protege
              la Zona V, que es una de las más delicadas del cuerpo. Esta nueva
              línea ayuda a cuidar y proteger el pH de tu zona íntima. Toda la
              línea Pro-Defense V contiene prebióticos (Inulina) ingrediente que
              conserva las defensas de tu zona V, manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions:
            '¿Cuáles son las características principales de esta nueva línea?',
          answer: (
            <p>
              Toda la línea Pro-Defense V contiene Inulina, que es un prebiótico
              importante y el cual ayuda a conservar las defensas de tu Zona V,
              manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions: '¿Es seguro usar estos nuevos productos?',
          answer: (
            <p>
              Claro que sí, la nueva línea Pro-Defense V está ginecológicamente
              testeada y dermatológicamente comprobada por médicos especialistas
            </p>
          ),
        },

        // {
        //   questions: '¿Qué son los prebióticos, la inulina y el ácido láctico?',
        //   answer: (
        //     <p>
        //       <li>
        //         Los prebióticos son componentes naturales que nutren a los
        //         probióticos, y estos últimos, son las bacterias necesarias para
        //         ayudar a mantener un pH saludable en pro de tu Zona V**.
        //       </li>
        //       <br />
        //       **Estudios de biología molecular sobre Lactobacillus y pH
        //       Balanceado
        //       <br />
        //       <br />
        //       <li>
        //         La inulina es un prebiótico compuesto de dos ingredientes
        //         naturales que ayudan a conservar las defensas de tu Zona V,
        //         manteniéndola en equilibrio.
        //       </li>
        //       <li>
        //         La inulina es un prebiótico compuesto de dos ingredientes
        //         naturales que ayudan a conservar las defensas de tu Zona V,
        //         manteniéndola en equilibrio.
        //       </li>
        //     </p>
        //   ),
        // },

        {
          questions: '¿Por qué se altera la Zona V?',
          answer: (
            <p>
              Tu Zona V se encuentra expuesta a situaciones cotidianas que
              pueden afectarla, como el uso de ropa estrecha, el uso de baños
              públicos o incluso sentarnos en las máquinas del gimnasio. Estas
              situaciones conllevan muchas veces a que tu Zona V se altere.
            </p>
          ),
        },

        {
          questions:
            'Si tengo una infección o tengo mi pH alterado, ¿Pro-Defense sirve?\n',
          answer: (
            <p>
              Si tienes alguna alteración en el pH de tu vagina, es importante
              que busques ayuda médica, ya que la línea Pro-Defense V es un
              complemento de tu higiene intima, que te ayudará a conservar las
              defensas naturales de tu zona V, no es un medicamento. PARA USO
              EXTERNO SOLAMENTE.
            </p>
          ),
        },

        {
          questions: '¿La línea Pro Defense-V es un medicamento?',
          answer: (
            <p>
              Este producto es un complemento de tu higiene íntima, no es un
              MEDICAMENTO. PARA USO EXTERNO SOLAMENTE.
            </p>
          ),
        },

        {
          questions: 'Diferencias entre probióticos y prebióticos',
          answer: (
            <p>
              Los probióticos son las bacterias beneficiosas que viven en el
              cuerpo y mejoran el equilibrio de la piel. <br />
              Los prebióticos son componentes naturales que nutren a los
              probióticos (bacterias beneficiosas), para ayudar a mantener un pH
              saludable en pro de tu Zona V.
            </p>
          ),
        },

        {
          questions: '¿Por qué se usan los prebióticos?',
          answer: (
            <p>
              Se utilizan para ayudar a conservar las defensas de tu Zona V,
              manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions:
            '¿Es necesario utilizar la línea completa en la rutina de higiene diaria?',
          answer: (
            <p>
              Para mejores resultados se recomienda el uso completo de la línea
              de productos Pro-Defense V. Se compone de protectores diarios,
              jabón íntimo y pañitos húmedos.{' '}
            </p>
          ),
        },

        {
          questions: '¿También hay Toallas Pro-Defense V?',
          answer: (
            <p>
              No, la línea Pro-Defense V se compone de protectores diarios,
              jabón íntimo y pañitos húmedos.
            </p>
          ),
        },

        {
          questions: '¿Cuántas veces al día debo cambiarme el protector?',
          answer: (
            <p>
              Recomendamos cambiar tus protectores diarios tres veces al día.
            </p>
          ),
        },

        {
          questions: '¿Esta línea la pueden usar las niñas?',
          answer: (
            <p>
              ¡Claro que sí! Esta línea es ideal para mujeres de todas las
              edades.
            </p>
          ),
        },
      ]
  }
}
